export const getAuctionData = (state) => {
  const {
    auction
  } = state;

  return auction;
}